import React, { useContext, useEffect, useState } from "react";
import { FaTrophy } from "react-icons/fa";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import PageTitle from "../../../jsx/layouts/PageTitle";
import KpiCard from "../NewDashboard/KpiCard";
import ChartCard from "../NewDashboard/ChartCard";
import "../NewDashboard/style.css";
import { getCmTrophyStats, getCmTrophyWeeklyStats } from "../../../services/adminApiService/cmTrophyApi/cmTrophyApi";
import CmTrophyApplicationsTable from "./CmTrophyApplicationsTable";
import { AuthContext } from "../../../context/AuthContext";

const CmTrophyDashboard = () => {
  const { userData } = useContext(AuthContext);
  const isSuperAdmin = userData?.email === "ukadmin@gmail.com";

  const [stats, setStats] = useState({ total: 0, submitted: 0, under_review: 0, approved: 0, rejected: 0 });
  const [statsLoading, setStatsLoading] = useState(true);
  const [weeklyData, setWeeklyData] = useState([]);

  useEffect(() => {
    const fetchStats = () =>
      getCmTrophyStats()
        .then((res) => {
          const d = res?.data?.data || {};
          const byStatus = d.by_status || {};
          const total = Number(d.total || 0);
          const approved = Number(byStatus.approved || 0);
          const rejected = Number(byStatus.rejected || 0);
          setStats({ total, approved, rejected, under_review: total - approved - rejected });
        })
        .catch(() => {})
        .finally(() => setStatsLoading(false));

    fetchStats();
    const interval = setInterval(fetchStats, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!isSuperAdmin) return;
    const fetchWeekly = () =>
      getCmTrophyWeeklyStats()
        .then((res) => setWeeklyData(res?.data?.data?.weeklyRegistrationData || []))
        .catch(() => {});

    fetchWeekly();
    const interval = setInterval(fetchWeekly, 60000);
    return () => clearInterval(interval);
  }, [isSuperAdmin]);

  const cards = [
    { label: "Total Applications", value: stats.total },
    { label: "Under Review", value: stats.under_review },
    { label: "Approved", value: stats.approved },
    { label: "Rejected", value: stats.rejected },
  ];

  return (
    <>
      <PageTitle activeMenu="Dashboard" motherMenu="CM Trophy" />
      <div className="row g-4 mb-4 mt-1">
        {cards.map(({ label, value }) => (
          <div key={label} className="col-6 col-md-4 col-lg d-flex">
            <KpiCard
              title={label}
              value={value}
              icon={<FaTrophy size={22} color="#8757e8" />}
              loading={statsLoading}
            />
          </div>
        ))}
      </div>
      {isSuperAdmin && (
        <div className="row g-4 mb-4">
          <div className="col-12">
            <ChartCard title="Total Registration" badge="Weekly">
              <ResponsiveContainer width="100%" height={160}>
                <LineChart data={weeklyData}>
                  <XAxis dataKey="name" />
                  <YAxis allowDecimals={false} />
                  <Tooltip />
                  <Line dataKey="value" stroke="#8757e8" />
                </LineChart>
              </ResponsiveContainer>
            </ChartCard>
          </div>
        </div>
      )}
      <CmTrophyApplicationsTable />
    </>
  );
};

export default CmTrophyDashboard;
